var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    id: "maybe-creation-large",
    "data-supported-dps": "48x48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 16.5,
    fill: "#deb8dc",
    stroke: "#523951",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 33.66l11.48-1.92a1.9 1.9 0 012.2 1.58 2 2 0 01-1.56 2.18l-4.81.81a1.53 1.53 0 011.17.29 1.55 1.55 0 01.62 1 1.63 1.63 0 01-1.22 1.84 1.58 1.58 0 01.84 1.16 1.68 1.68 0 01-1 1.82 1.57 1.57 0 01.28 1.16 1.74 1.74 0 01-1.5 1.54l-.56.12q-2.18.46-4.38.72a27.87 27.87 0 01-5-.39 3.31 3.31 0 01-2.43-2.15c-1.09-2.27-1.69-6.56-.35-7.8a4.31 4.31 0 001.75-2.4c.64-1.47 1.31-3.16 1.82-4.6s.71-2.09 1.66-2.44a1.94 1.94 0 012.34 1.11 8 8 0 01-.14 3c-.24 2-.25 2.46 0 3.14",
    fill: "#deb8dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.48 31.74a1.9 1.9 0 012.2 1.58 2 2 0 01-1.56 2.18l-4.81.81a1.53 1.53 0 011.17.29 1.55 1.55 0 01.62 1 1.63 1.63 0 01-1.22 1.84 1.58 1.58 0 01.84 1.16 1.68 1.68 0 01-1 1.82 1.57 1.57 0 01.28 1.16 1.74 1.74 0 01-1.5 1.54l-.56.12q-2.18.46-4.38.72a27.87 27.87 0 01-5-.39 3.31 3.31 0 01-2.43-2.15c-1.09-2.27-1.69-6.56-.35-7.8a4.31 4.31 0 001.75-2.4c.64-1.47 1.31-3.16 1.82-4.6s.71-2.09 1.66-2.44a1.94 1.94 0 012.34 1.11 8 8 0 01-.14 3c-.24 2-.25 2.46 0 3.14zM16 14a4.19 4.19 0 012.75-1.23 4.18 4.18 0 012.94.67M22 27h3",
    fill: "none",
    stroke: "#523951",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 20,
    r: 2,
    fill: "#523951"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 22,
    r: 2,
    fill: "#523951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 16.68a4.19 4.19 0 013 0 4.2 4.2 0 012.45 1.71",
    fill: "none",
    stroke: "#523951",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThink);
export default __webpack_public_path__ + "static/media/think.29bdab3f6d113f73fb6179100bf78622.svg";
export { ForwardRef as ReactComponent };